import { render, staticRenderFns } from "./ElementFormCheckboxList.vue?vue&type=template&id=c1e18d22&"
import script from "./ElementFormCheckboxList.vue?vue&type=script&lang=js&"
export * from "./ElementFormCheckboxList.vue?vue&type=script&lang=js&"
import style0 from "./ElementFormCheckboxList.vue?vue&type=style&index=0&id=c1e18d22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports